import {
  SetContentAction,
  SetTokensAction,
  setContent,
  setContentType,
  setTokens,
  setTokensType
} from '@spa/lib/store/session/sessionSlice';
import { actionChannel, put, race, select, take } from 'typed-redux-saga';
import { SessionStateContent } from '@spa/lib/store/session/SessionState';
import createBroadcastEventChannel from '@spa/lib/store/sagas/createBroadcastEventChannel';
import { hydrateType } from '@spa/lib/store/HydrateAction';
import selectOptionalSessionContent from '@spa/lib/store/session/selectors/selectOptionalSessionContent';

const reduxInitType = '@@INIT';

function* watchAndNotifySessionChanges(): Generator {
  let broadcastChannel: BroadcastChannel | undefined;
  if (BroadcastChannel !== undefined) {
    broadcastChannel = new BroadcastChannel('mul-sessions');
  }

  const broadcastEventChannel = createBroadcastEventChannel<SessionStateContent>(broadcastChannel);

  const requestChan = yield* actionChannel([
    setContentType,
    setTokensType,
    hydrateType,
    reduxInitType
  ]);
  let lastSessionContent: SessionStateContent | null = null;
  while (true) {
    const { action, broadcast } = yield* race({
      action: take(requestChan),
      broadcast: take(broadcastEventChannel)
    });
    if (action !== undefined) {
      const sessionContent: SessionStateContent | null = yield* select(
        selectOptionalSessionContent
      );
      if (lastSessionContent !== null && lastSessionContent !== sessionContent) {
        let propagateChanges: boolean = true;
        if (setContent.match(action)) {
          const setContentAction: SetContentAction = action;
          propagateChanges = setContentAction.payload.localChange;
        } else if (setTokens.match(action)) {
          const setTokensAction: SetTokensAction = action;
          propagateChanges = setTokensAction.payload.localChange;
        }

        if (propagateChanges) {
          broadcastChannel?.postMessage(sessionContent);
        }
      }
      lastSessionContent = sessionContent;
    } else if (broadcast !== undefined) {
      yield* put(
        setContent({
          localChange: false,
          content: broadcast
        })
      );
    }
  }
}

export default watchAndNotifySessionChanges;
